export default class VideoController {
  constructor() {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.play();
        } else {
          entry.target.pause();
        }
      });
    }, {});

    // initialize playback on load
    document.addEventListener('turbo:load', evt => this.initializePlayback(evt));

    // stop the videos when navigating away
    document.addEventListener('turbo:before-cache', evt => this.stopVideos(evt));

    // stop the videos when the tab is not visible
    document.addEventListener("visibilitychange", evt => this.onVisibilityChange(evt));
  }

  onVisibilityChange() {
    const videos = document.querySelectorAll("video");
    for (const video of videos) {
      if (document.hidden) {
          video.pause();
          this.observer.unobserve(video);
      } else {
        this.observer.observe(video);
      }
    }
  }

  initializePlayback() {
    const videos = document.querySelectorAll("video");

    for (const video of videos) this.observer.observe(video);
  }

  stopVideos() {
    const videos = document.querySelectorAll("video");
    for (const video of videos) {
      video.pause();
      this.observer.unobserve(video);
    }
  }
}

